import { z } from 'zod';
/**
 * Typed error codes. The client never receives a raw error string — it receives
 * one of these codes plus an optional detail object, and renders a translated
 * message from its own i18next catalogue. Adding a code here means adding a
 * translation in both he and en.
 */
export const errorCodeSchema = z.enum([
    'unauthenticated',
    'invalid_token',
    'forbidden',
    'not_found',
    'validation_failed',
    'conflict',
    'rate_limited',
    'internal',
]);
export const apiErrorSchema = z.object({
    error: z.object({
        code: errorCodeSchema,
        /** Non-localised, developer-facing. Never rendered to an end user. */
        message: z.string(),
        details: z.record(z.string(), z.unknown()).optional(),
        requestId: z.string(),
    }),
});
export const HTTP_STATUS_FOR_ERROR = {
    unauthenticated: 401,
    invalid_token: 401,
    forbidden: 403,
    not_found: 404,
    validation_failed: 400,
    conflict: 409,
    rate_limited: 429,
    internal: 500,
};
//# sourceMappingURL=errors.js.map